"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayStatus = void 0;
exports.MangopayStatus = {
    SUCCEEDED: "SUCCEEDED",
    FAILED: "FAILED",
    CREATED: "CREATED",
};
//# sourceMappingURL=MangopayStatus.js.map